import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchAllGetVesselList = (data) => {
  return axios.get(`${apiurl?.getPpeVesselList}?searchCriteria=${data?.searchCriteria}&Page=${data?.Page}&PageSize=${data?.PageSize}&isAll=${data?.isAll}&vesselGroupId=${data?.vesselGroupId ? data?.vesselGroupId : ''}`);
};

const getVesselList = (data) => {
  return useQuery(['getPpeVesselList', data], () => fetchAllGetVesselList(data), { refetchOnWindowFocus: false });
};

export default getVesselList;
